import React from 'react';

import Loader from 'components/Loader';
import ItemPost from 'templates/pages/GuidePost';

import withPreview from '@/hoc/withPreview';
import { guidePost } from 'constants/graphql/guidePost';

const GuidePost = ({ pageContext, loaded, ...props }) => {
  if (!loaded) return <Loader />;

  return <ItemPost {...pageContext} {...props} />;
};

const queryPreview = `
query GuidePostQuery($id: ID = "") {
  guide(id: $id, idType: DATABASE_ID, asPreview: true) {
    ${guidePost()}
    revisions(first:1) {
      nodes {
        ${guidePost()}
      }
    }
  }
}
`;

export default withPreview(GuidePost, {
  queryPreview,
});
